export default function WhyNectr() {
    return (
        <section className="whynectr-section">
            <div className="container">
                <div className="text-center mb-5">
                    <span className="eyebrow">Why Nectr Studio</span>
                    <h2 className="results-title">Built for hospitality from the ground up</h2>
                    <p className="results-sub">
                        Every site is designed with your venue’s personality and your guests in mind
                    </p>
                </div>

                <div className="whynectr-grid">
                    {[
                        {
                            icon: "⚡",
                            title: "Fast launch",
                            text: "Most sites go live in 2–3 weeks once content is ready."
                        },
                        {
                            icon: "🎨",
                            title: "Designed for your brand",
                            text: "Custom colors, fonts, and layout. No cookie-cutter themes."
                        },
                        {
                            icon: "🤝",
                            title: "Ongoing partnership",
                            text: "We handle updates and optimizations so you can focus on guests."
                        }
                    ].map((item) => (
                        <div key={item.title} className="whynectr-item">
                            <div className="whynectr-icon">{item.icon}</div>
                            <h3>{item.title}</h3>
                            <p>{item.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
